import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project import
import Drawer from './Drawer';
import Header from './Header';
import navigation from '../../menu-items';
import Loader from '../../components/Loader';
import Breadcrumbs from '../../components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from '../../api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const drawerOffset = drawerOpen ? 260 : 64;

  useEffect(() => {
    handlerDrawerOpen(!downMD);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downMD]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        background: '#f5f7fa'
      }}
    >
      <Header />
      <Drawer />
      <Box
        component="main"
        sx={{
          width: { xs: '100%', md: `calc(100% - ${drawerOffset}px)` },
          flexGrow: 1,
          minWidth: 0,
          p: { xs: 2, sm: 3 },
          pt: { xs: 2, sm: 3 },
          bgcolor: '#f5f7fa',
          transition: (theme) =>
            theme.transitions.create(['width'], {
              easing: theme.transitions.easing.sharp,
              duration: drawerOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen
            })
        }}
      >
        <Toolbar />
        <Breadcrumbs navigation={navigation} title />
        <Outlet />
      </Box>
    </Box>
  );
}
